import { useCallback, useEffect, useRef, useState } from 'react';

import { BILLBOARD, KPIS } from 'constants/Entities';
import { DRAWER_DEFAULT_WIDTH, DRAWER_OFFSET } from 'constants/Constants';

const useDrawerWidth = ({ entityType, isOpen }) => {
    const [windowWidth, setWindowWidth] = useState(window.innerWidth);
    const lastWidthRef = useRef(DRAWER_DEFAULT_WIDTH);

    const getDrawerWidth = useCallback(() => {
        switch (entityType) {
            case BILLBOARD:
            case KPIS:
                return DRAWER_DEFAULT_WIDTH;
            default:
                return windowWidth - DRAWER_OFFSET;
        }
    }, [entityType, windowWidth]);

    const currentWidth = getDrawerWidth();

    useEffect(() => {
        if (isOpen && entityType) {
            lastWidthRef.current = currentWidth;
        }
    }, [isOpen, entityType, currentWidth]);

    useEffect(() => {
        const handleResize = () => {
            setWindowWidth(window.innerWidth);
        };

        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    const drawerWidth = isOpen ? currentWidth : lastWidthRef.current;

    return drawerWidth;
};

export default useDrawerWidth;
